import styles from './mapComponent.module.scss';


/**
 * @returns Iframe Google map component
 */
const MapComponent = () => {
    return (
        <div className={`${styles.mapResponsive}`}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.9456979513748!2d152.96352561565516!3d-26.841679396711534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b9385989dbc462d%3A0x3d1b1b08331c54df!2sThe%20Crocodile%20Hunter%20Lodge!5e0!3m2!1sen!2sau!4v1658187838377!5m2!1sen!2sau"
                width="600"
                height="450"
                style={{ border: 0 }}
                loading={`lazy`}>
            </iframe>
        </div>
    )
}

export default MapComponent;